// import React from 'react';
import {useState} from 'react';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import ForcedLogout from '../../function/ForcedLogout'
import * as Common from '../../../common'

axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';

function InputAndSelect(props:any) {

    const history = useHistory();

    /**
     * 選択肢
     */
    const [choises,setChoises]=useState<Array<any>>([])

    /**
     * メニューが開いているかどうか
     */
    const [isMenuOpen,setStateMenuOpen]=useState<boolean>(false);

    /**
     * エラーが出ているかどうか
     */
    const [isError,setStateError]=useState<boolean>(false)

    /**
     * ボタンを押したとき
     */
    const onClickButton=()=>{

        //メニューが閉じている場合
        if(!isMenuOpen){

            //paramsを作成
            const apiObj:any={
                headers:{
                    Authorization: `Bearer ${props.token}`
                }
            }
            if(props.displayValue!==''){
                apiObj.params={
                    [props.apiParamKey]:`like:${props.displayValue}`
                }
            }

            //axiosの前に、他端末がログインしていたらログアウト
            ForcedLogout(history,props.token)

            //axios
            axios.get(`${Common.API_DOMAIN()}/api${props.apiPath}`,apiObj)
            .then(response=>{

                //変数に選択肢を格納
                setChoises(response.data)

                //もし選択肢の個数が1個以上であれば
                if(response.data.length>=1){
                    //メニューを開く
                    setStateMenuOpen(true)
                }
            })
            .catch(error=>{
                console.error({error})
                //エラーコードが401のとき（＝トークン有効期限切れのとき）
                if({error}.error.response.status==='401'){
                    //強制ログアウト
                    ForcedLogout(history, props.token)
                }
            })
        }else{
            //メニューが開いていたら閉じる
            setStateMenuOpen(false)
        }
    }

    return(
        <div className="form__item-input-inner form__item-input-inner--input-and-select">
            <input type="text" value={props.displayValue} onChange={(e:any) => {

                //フォームの値を直接変更した場合、検索条件を空にする
                props.onChangeValue('')

                props.onChangeDisplayValue(e.target.value)

                //エラーの状態を設定
                setStateError(e.target.value.length>0&&props.optionValue===''?true:false)
            }}/>
            <div className="select-input" data-is-open={isMenuOpen}>
                <div className="select-input__input">
                    <input type="text" defaultValue={props.optionValue} className="select-input__input-form" readOnly/>
                    <div className="select-input__input-menu">
                        <ul className="select-input__input-menu-list">
                            <li className="select-input__input-menu-item">
                                <a className="select-input__input-menu-link" onClick={()=>{
                                    //displayValueに、選択項目の特定の値を設定
                                    props.onChangeDisplayValue('')

                                    //グレーの箇所にも表示
                                    props.onChangeOptionValue('')

                                    //メニューを閉じる
                                    setStateMenuOpen(false)

                                    //エラーの状態を設定
                                    setStateError(props.displayValue>0&&props.optionValue===''?true:false)

                                    //設定した値を親コンポーネントに送信
                                    props.onChangeValue('')
                                    }}>
                                </a>
                            </li>
                            {
                                choises.map((choise,index)=>{
                                    return(
                                        <li className="select-input__input-menu-item" key={index}>
                                            <a className="select-input__input-menu-link" onClick={()=>{
                                                //choisesのコピーを作成
                                                const choiseTemp= Object.assign({}, choise)

                                                //selectedItemに、選択項目の特定の値を設定
                                                props.onChangeDisplayValue(choiseTemp[props.setItemProp])

                                                //グレーの箇所にも表示
                                                props.onChangeOptionValue(choiseTemp[props.displayItemProp])

                                                //メニューを閉じる
                                                setStateMenuOpen(false)
                                                
                                                //エラーの状態を設定
                                                setStateError(props.displayValue>0&&props.optionValue===''?true:false)

                                                //設定した値を親コンポーネントに送信
                                                props.onChangeValue(choiseTemp[props.searchItemProp])
                                                }}>
                                                {choise[props.displayItemProp]}
                                            </a>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                </div>
                <div className="select-input__btn">
                    <button type="button" onClick={onClickButton}>
                        ・・・
                    </button>
                </div>
            </div>
            { isError&&
                (
                    <div className="input-and-select-error">
                        {props.name}を1つ選択してください。
                    </div>
                )
            }
        </div>
    );
}


export default InputAndSelect;